import React from 'react';

import { ForwardModal, popupModel } from 'src/components/complex';
import { ReplyModal } from 'src/components/complex/contact/ReplyModal';
import AlertManager from 'src/components/alert/AlertManager';
import AddTreatment from 'src/components/treatments/Create';
import treatmentsModel from 'src/components/messages/treatmentsModel';

import config from 'src/config';

import { lang, remCss, userFullName, withRouter, events, permissions } from 'src/helpers';

import { GENERAL_ICONS } from '../svg';
import { Avatar, MCButton } from '../basic';
import LANG_CONST from 'src/helpers/lang/const';

const { PAGES, ACTIONS } = permissions;

const TreatmentDetail = (props) => {
  let { item, onSeeMore, onForward, onReply, router, showDoctor = false } = props;
  let { data } = item;
  const screen = props.screenDetail;
  const [currentTime, setCurrentTime] = React.useState(Date.now);

  React.useEffect(() => {
    const intervalId = window.setInterval(() => {
      setCurrentTime(Date.now());
    }, 60000);

    return () => window.clearInterval(intervalId);
  }, []);

  const click = (action) => () => {
    switch (action) {
      case 'reply':
        popupModel.setActivePopup('reply', {
          active: true,
          component: ReplyModal,
          props: {
            onSubmit: (text, hide) => {
              events.emit('replyOrForwardedMsg', {
                partnerId: item.to,
                originalMsg: {
                  ...item,
                  msgType: 'treatment',
                  text,
                  data: { ...item.data, treatmentId: item.id }
                },
                type: 'reply'
              });
              router.navigate(PAGES.MESSAGES_USER_PAGE.match(item.to));
              hide();
            }
          }
        });
        break;
      case 'forward':
        popupModel.setActivePopup('forward', {
          active: true,
          component: ForwardModal,
          props: {
            onSelect: (user, hide) => {
              events.emit('replyOrForwardedMsg', {
                partnerId: user.id,
                partner: user,
                originalMsg: {
                  ...item,
                  msgType: 'treatment',
                  data: { ...item.data, treatmentId: item.id }
                },
                type: 'forward'
              });
              router.navigate(PAGES.MESSAGES_USER_PAGE.match(user.id));
              hide();
            }
          }
        });
        break;
      case 'seemore':
        router.navigate(PAGES.TREATMENTS_DETAIL_PAGE.match(item.id), {
          state: { treatment: item }
        });
        break;
    }
  };
  const doctor = item.doctor || item.fromUser || {};

  const openEditTreatment = () => {
    let item2 = {
      ...item,
      id: 0,
      treatmentId: item.id,
      messageId: 0,
      msgType: 'treatment',
      partnerId: item.to || item.partnerId || item.partner?.id
    };
    // events.emit('openEditTreatment', item2);
    // console.warn('openEditTreatment', item2, item);
    popupModel.setActivePopup(ACTIONS.TREATMENTS_ADD_BUTTON.key, {
      active: true,
      component: AddTreatment,
      props: {
        editItem: item2,
        partnerId: item2.partnerId,
        afterSave: (error, data, success) => {
          if (success) {
            data = treatmentsModel.mapItem(data);
            treatmentsModel.filterItem(data);
          }
        }
      }
    });
  };

  const openRemoveTreatment = () => {
    AlertManager.popup(AlertManager.TYPES.WARN, {
      title: lang.t(LANG_CONST.notice.delete_selected, { name: item?.text }),
      close: false,
      actionButton: {
        label: LANG_CONST.buttons.yes,
        action: ({ hide }) => {
          treatmentsModel.remove(item.id, item);
          hide();
        }
      },
      cancelButton: {
        label: LANG_CONST.buttons.no,
        action: (props) => {
          props.hide();
        }
      }
    });
  };

  // console.warn(
  //   'TreatmentDetail item:',
  //   item.own,
  //   item.date,
  //   item,
  //   item.date > Date.now() - config.get('editTreatmentsTime')
  // );

  let recommendation = data?.tagRecommendations?.length > 0 && (
    <div className={'mc-flex-col mc-grow'}>
      <div className={'mc-value-618'}>{lang.t(LANG_CONST.recommendations)}</div>
      <div className={'mc-flex mc-wrap'}>
        {data?.tagRecommendations?.map((item, i) =>
          item.tags.map((tag) => (
            <MCButton
              quaternary
              small
              rounded
              light
              style={{
                paddingHorizontal: remCss(12),
                paddingVertical: remCss(8)
              }}
              key={i + tag}
            >
              {tag.trim()}
            </MCButton>
          ))
        )}
      </div>
    </div>
  );
  return (
    <div className={'mc-treatment-detail mc-flex-15-col'}>
      <div className={'mc-flex'}>
        {showDoctor && (
          <div className={'mc-flex mc-grow'}>
            <Avatar text={userFullName(doctor)} width={80} height={80} image={doctor.avatar} />
            <div className={'mc-flex-5-col'}>
              <div className={'mc-value-518'}>{userFullName(doctor, doctor.isDoctor)}</div>
              <div className={'mc-label-418'}>
                {doctor.specialist
                  ?.filter((v) => !!LANG_CONST.constants.specialist[v])
                  .map((v) => lang.t(LANG_CONST.constants.specialist[v]))
                  .join(', ')}{' '}
              </div>
            </div>
          </div>
        )}
        {!screen.isSmallScreen && recommendation}
      </div>
      {screen.isSmallScreen && recommendation}
      <div className={'mc-flex-10-col'}>
        <div className={'mc-value-618'}>{lang.t(LANG_CONST.prescribe_medicine)}</div>
        <div className={'mc-flex mc-plr10 mc-ptb5'}>
          <div className={'mc-grow mc-label-516'}>{lang.t(LANG_CONST.medicine)}</div>
          <div className={'mc-grow mc-label-516'}>{lang.t(LANG_CONST.dosage)}</div>
          <div className={'mc-grow mc-label-516'} style={{ maxWidth: remCss(150) }}>
            {lang.t(LANG_CONST.duration)}
          </div>
        </div>
        {data.medicines.map((item, i) => (
          <div className={'mc-flex mc-p10 mc-medicine-row'} key={i}>
            <div className={'mc-grow mc-value-418'}>{item.name}</div>
            <div className={'mc-grow mc-value-418'}>
              {item.times
                .map((time) => item.doze + ' ' + lang.t(LANG_CONST.constants.medicine_times[time]))
                .join(', ') +
                ' (' +
                lang.t(LANG_CONST.constants.medicine_period[item.period]) +
                ')'}
            </div>
            <div className={'mc-grow mc-value-418'} style={{ maxWidth: remCss(150) }}>
              {lang.t(item.days > 1 ? LANG_CONST.amount_day : LANG_CONST.amount_days, {
                amount: item.days
              })}
            </div>
          </div>
        ))}
      </div>
      <div className={'mc-flex'}>
        <div className={'mc-flex mc-grow'}>
          {ACTIONS.TREATMENTS_REPLY_BUTTON.isActive && (
            <MCButton
              small
              primary
              light
              radius
              iconname={GENERAL_ICONS.REPLY}
              onClick={onReply ? () => onReply(item) : click('reply')}
              label={LANG_CONST.buttons.reply}
            />
          )}
          {ACTIONS.TREATMENTS_ADD_BUTTON.isActive &&
            item.own &&
            item.date > currentTime - config.get('editTreatmentsTime') && (
              <>
                <MCButton
                  small
                  primary
                  light
                  radius
                  // iconname={GENERAL_ICONS.REPLY}
                  onClick={() => openEditTreatment()}
                  label={LANG_CONST.buttons.edit}
                />
                <MCButton
                  small
                  primary
                  light
                  radius
                  // iconname={GENERAL_ICONS.REPLY}
                  onClick={() => openRemoveTreatment()}
                  label={LANG_CONST.buttons.remove}
                />
              </>
            )}
          {ACTIONS.TREATMENTS_FORWARD_BUTTON.isActive && (
            <MCButton
              small
              primary
              light
              radius
              iconname={GENERAL_ICONS.FORWARD}
              onClick={onForward ? () => onForward(item) : click('forward')}
              label={LANG_CONST.buttons.forward}
            />
          )}
        </div>
        <MCButton
          medium
          primary
          light
          radius
          onClick={onSeeMore ? () => onSeeMore(item) : click('seemore')}
          label={LANG_CONST.buttons.see_more}
        />
      </div>
    </div>
  );
};

export default withRouter(TreatmentDetail);
